import { ReactElement, ReactNode } from 'react';
import ReactTooltip from 'react-tooltip';
import { colors } from 'styles/colors';
import { InfoIconCR } from 'icons';
import { useMediaQuery } from '~/hooks/useMediaQuery';

function clampToViewport(
  position: { left: number; top: number },
  _currentEvent: Event,
  _currentTarget: EventTarget,
  node: HTMLDivElement | HTMLSpanElement | null,
): { left: number; top: number } {
  const VIEWPORT_PADDING = 10;

  if (!node) return position;

  const clampedLeft = Math.max(
    VIEWPORT_PADDING,
    Math.min(position.left, window.innerWidth - node.offsetWidth - VIEWPORT_PADDING),
  );
  const clampedTop = Math.max(
    VIEWPORT_PADDING,
    Math.min(position.top, window.innerHeight - node.offsetHeight - VIEWPORT_PADDING),
  );

  const wasOverridden = clampedLeft !== position.left || clampedTop !== position.top;
  node.classList.toggle('tooltip-arrow-hidden', wasOverridden);

  return { left: clampedLeft, top: clampedTop };
}

interface InfoTooltipProps {
  id: string;
  children: ReactNode;
  disabled?: boolean;
}

export function InfoTooltip({
  id,
  children,
  disabled,
}: Readonly<InfoTooltipProps>): ReactElement {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      <ReactTooltip
        id={`tooltip-${id}-info`}
        place="bottom"
        type="light"
        effect="solid"
        delayHide={100}
        offset={{ top: 0, left: -2 }}
        backgroundColor={colors.bg['white-0']}
        border
        borderColor={colors.stroke['soft-200']}
        padding="4px"
        className="tooltip-bignumber"
        disable={disabled}
        overridePosition={clampToViewport}
        clickable={isMobile}
      >
        {children}
      </ReactTooltip>
      <div
        data-tip
        data-for={`tooltip-${id}-info`}
        style={{ width: 18, height: 18, display: 'flex' }}
      >
        <InfoIconCR />
      </div>
    </>
  );
}
